import React, { useState } from "react";
import { Flame } from "lucide-react";
import HelpSupportModal from "@/components/HelpSupportModal";

export default function CohortBanner() {
  const [helpOpen, setHelpOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setHelpOpen(true)}
        data-testid="cohort-urgency-banner"
        className="inline-flex items-center gap-2 bg-indigo-500/10 hover:bg-indigo-500/20 border border-indigo-400/30 rounded-full px-4 py-1.5 text-xs sm:text-sm font-semibold text-indigo-300 transition-colors"
      >
        <span className="relative flex h-2 w-2 shrink-0">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-indigo-400 opacity-75" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-indigo-400" />
        </span>
        <Flame className="w-3.5 h-3.5 shrink-0" />
        New batch enrolling now — limited seats, reserve yours
      </button>
      <HelpSupportModal open={helpOpen} onClose={() => setHelpOpen(false)} />
    </>
  );
}
